export default "__VITE_ASSET__3YW4DwNl__"